export const ARC_SERVICE = import.meta.env.VITE_ARC_SERVICE;
export const PHISH_SERVICE = import.meta.env.VITE_PHISH_SERVICE;
export const PHISHING_SIMULATION = import.meta.env
  .VITE_PHISING_SIMULATION_SERVICE;
export const SAT_SERVICE = import.meta.env.VITE_SAT_SERVICE;
